import adminActivityEventList from './admin-activity-event-list'
import adminOwnerList from './admin-owner-list'
import adminReactionList from './admin-reaction-list'
import adminStartupApplicationList from './admin-startup-application-list'
import adminSubscriptionList from './admin-subscription-list'
import adminUserList from './admin-user-list'
import chat from './chat'
import common from './common'
import countries from './countries'
import dashboardStartup from './dashboard-startup'
import eventDetails from './event-details'
import eventList from './event-list'
import investorList from './investor-list'
import investorLogs from './investor-logs'
import investorProfile from './investor-profile'
import investorProfileTemp from './investor-profile-temp'
import marketplacePartnerships from './marketplace-partnerships'
import notifications from './notifications'
import organizationDetails from './organization-details'
import organizationList from './organization-list'
import organizationProgramApplicationDetails from './organization-program-application-details'
import organizationProgramApplications from './organization-program-applications'
import organizationProgramDetails from './organization-program-details'
import organizationProgramList from './organization-program-list'
import organizationStartupsFunnel from './organization-startups-funnel'
import startupApplicationDetails from './startup-application-details'
import startupApplications from './startup-applications'
import startupChangelog from './startup-changelog'
import startupList from './startup-list'
import startupOwners from './startup-owners'
import startupProfileInvestorClassifies from './startup-profile-investor-classifies'
import startupProfile from './startup-profile'
import user from './user'

export default {
  adminActivityEventList,
  adminOwnerList,
  adminReactionList,
  adminStartupApplicationList,
  adminSubscriptionList,
  adminUserList,
  chat,
  common,
  countries,
  dashboardStartup,
  eventDetails,
  eventList,
  investorList,
  investorLogs,
  investorProfile,
  investorProfileTemp,
  marketplacePartnerships,
  notifications,
  organizationDetails,
  organizationList,
  organizationProgramApplicationDetails,
  organizationProgramApplications,
  organizationProgramDetails,
  organizationProgramList,
  organizationStartupsFunnel,
  startupApplicationDetails,
  startupApplications,
  startupChangelog,
  startupList,
  startupOwners,
  startupProfileInvestorClassifies,
  startupProfile,
  user,
}
